(function () {
  'use strict';

  /* ---------- DOM ---------- */
  var page = document.querySelector('[data-reserve-page]');
  if (!page) return;

  var stepItems      = page.querySelectorAll('[data-rp-step]');
  var panels         = page.querySelectorAll('[data-rp-panel]');
  var layout         = page.querySelector('[data-rp-layout]');
  var confirmation   = page.querySelector('[data-rp-confirmation]');
  var searchInput    = page.querySelector('[data-rp-pincode]');
  var storeList      = page.querySelector('[data-rp-stores]');
  var skipWrap       = page.querySelector('[data-rp-skip]');
  var skipBtn        = page.querySelector('[data-rp-skip-btn]');
  var formErrors     = page.querySelector('[data-rp-form-errors]');
  var ctaBtn         = page.querySelector('[data-rp-cta]');
  var summaryHelper  = page.querySelector('[data-rp-summary-helper]');
  var summaryStore   = page.querySelector('[data-rp-summary-store]');
  var selStoreName   = page.querySelector('[data-rp-selected-store-name]');
  var selStoreAddr   = page.querySelector('[data-rp-selected-store-address]');
  var hiddenForm     = document.getElementById('reserve-page-contact-form');

  /* Product DOM — summary panel */
  var productImg     = page.querySelector('[data-rp-product-img]');
  var productName    = page.querySelector('[data-rp-product-name]');
  var productBrand   = page.querySelector('[data-rp-product-brand]');
  var productPrice   = page.querySelector('[data-rp-product-price]');
  var productCompare = page.querySelector('[data-rp-product-compare]');
  var productDiscount = page.querySelector('[data-rp-product-discount]');
  var productBlock   = page.querySelector('[data-rp-product]');

  /* Product DOM — confirmation panel */
  var confProductImg     = page.querySelector('[data-rp-conf-product-img]');
  var confProductName    = page.querySelector('[data-rp-conf-product-name]');
  var confProductBrand   = page.querySelector('[data-rp-conf-product-brand]');
  var confProductPrice   = page.querySelector('[data-rp-conf-product-price]');
  var confProductCompare = page.querySelector('[data-rp-conf-product-compare]');

  /* ---------- State ---------- */
  var state = {
    step: 1,
    product: null,
    store: null,
    customer: null
  };

  /* ---------- Store data from Storefront API ---------- */
  var stores = [];
  var shopDomain = page.dataset.shopDomain || '';
  var storefrontToken = page.dataset.storefrontToken || '';

  function fetchLocations() {
    if (!shopDomain || !storefrontToken) return Promise.resolve([]);

    var query = '{ locations(first: 50) { edges { node { id name address { address1 address2 city province zip country phone } } } } }';

    return fetch('https://' + shopDomain + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken
      },
      body: JSON.stringify({ query: query })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (!json.data || !json.data.locations) return [];
        return json.data.locations.edges.map(function (edge) {
          var loc = edge.node;
          var addr = loc.address || {};
          return {
            name: loc.name || '',
            address: [addr.address1, addr.address2].filter(Boolean).join(', '),
            city: addr.city || '',
            province: addr.province || '',
            postal_code: addr.zip || '',
            country: addr.country || '',
            phone: addr.phone || ''
          };
        });
      })
      .catch(function () { return []; });
  }

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var moneyFormat = page.dataset.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator_no_decimals}}', Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ---------- Read product info from URL params ---------- */
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('handle') || '';

  if (productHandle) {
    fetch('/products/' + productHandle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var variantId = params.get('variant');
        var variant = data.variants[0];
        if (variantId) {
          var found = data.variants.find(function (v) { return v.id === parseInt(variantId, 10); });
          if (found) variant = found;
        }

        var comparePrice = variant.compare_at_price;
        var discountPct = 0;
        if (comparePrice && comparePrice > variant.price) {
          discountPct = Math.round(((comparePrice - variant.price) / comparePrice) * 100);
        }

        state.product = {
          id: data.id,
          variantId: variant.id,
          title: data.title,
          vendor: data.vendor || '',
          price: variant.price,
          priceFormatted: formatMoney(variant.price),
          compareAtPrice: comparePrice,
          compareFormatted: comparePrice ? formatMoney(comparePrice) : '',
          discountPct: discountPct,
          image: data.featured_image || (data.images.length > 0 ? data.images[0] : ''),
          handle: data.handle
        };

        populateProduct();
      })
      .catch(function () {
        if (productBlock) productBlock.style.display = 'none';
      });
  } else {
    if (productBlock) productBlock.style.display = 'none';
  }

  function populateProduct() {
    var p = state.product;
    if (!p) return;

    /* Summary panel */
    if (productImg) { productImg.src = p.image; productImg.alt = p.title; }
    if (productName) productName.textContent = p.title;
    if (productPrice) productPrice.textContent = p.priceFormatted;
    if (productCompare) {
      if (p.compareAtPrice && p.compareAtPrice > p.price) {
        productCompare.textContent = p.compareFormatted;
      } else {
        productCompare.style.display = 'none';
      }
    }
    if (productDiscount) {
      if (p.discountPct > 0) {
        productDiscount.textContent = '(' + p.discountPct + '% OFF)';
      } else {
        productDiscount.style.display = 'none';
      }
    }

    /* Confirmation panel */
    if (confProductImg) { confProductImg.src = p.image; confProductImg.alt = p.title; }
    if (confProductName) confProductName.textContent = p.title;
    if (confProductBrand) confProductBrand.textContent = p.vendor;
    if (confProductPrice) confProductPrice.textContent = p.priceFormatted;
    if (confProductCompare) {
      if (p.compareAtPrice && p.compareAtPrice > p.price) {
        confProductCompare.textContent = p.compareFormatted;
      } else {
        confProductCompare.style.display = 'none';
      }
    }
  }

  /* ---------- Navigation ---------- */
  function goToStep(n) {
    state.step = n;

    /* Update step indicator badges */
    stepItems.forEach(function (el) {
      var s = parseInt(el.dataset.rpStep, 10);
      el.classList.remove('is-active', 'is-completed');
      if (s === n) el.classList.add('is-active');
      else if (s < n) el.classList.add('is-completed');
    });

    /* Toggle panels in left column */
    panels.forEach(function (el) {
      var s = parseInt(el.dataset.rpPanel, 10);
      el.classList.toggle('is-active', s === n);
    });

    /* Toggle layout vs confirmation */
    if (n <= 2) {
      if (layout) layout.hidden = false;
      if (confirmation) confirmation.classList.remove('is-active');
    } else {
      if (layout) layout.hidden = true;
      if (confirmation) confirmation.classList.add('is-active');
    }

    updateCtaState();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ---------- CTA state management ---------- */
  function updateCtaState() {
    if (!ctaBtn) return;

    if (state.step === 1) {
      ctaBtn.textContent = 'CONTINUE';
      ctaBtn.disabled = !state.store && !state.skippedStore;
    } else if (state.step === 2) {
      ctaBtn.textContent = 'RESERVE IN STORE';
      ctaBtn.disabled = false;
    }
  }

  /* ---------- Store rendering ---------- */
  function getInitials(name) {
    if (!name) return '?';
    var words = name.trim().split(/\s+/);
    if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }

  function renderStores(filtered) {
    if (!storeList) return;

    storeList.innerHTML = '';

    /* Show skip option only when search returns no results */
    if (skipWrap) {
      skipWrap.classList.toggle('is-visible', filtered.length === 0);
    }

    filtered.forEach(function (store) {
      var card = document.createElement('div');
      card.className = 'rp__store-card';
      if (state.store && state.store.name === store.name) {
        card.classList.add('is-selected');
      }

      /* Thumbnail with initials */
      var thumb = document.createElement('div');
      thumb.className = 'rp__store-thumb';
      thumb.textContent = getInitials(store.name);
      card.appendChild(thumb);

      /* Info */
      var info = document.createElement('div');
      info.className = 'rp__store-info';

      var nameEl = document.createElement('div');
      nameEl.className = 'rp__store-name';
      nameEl.textContent = store.name;
      info.appendChild(nameEl);

      var addrEl = document.createElement('div');
      addrEl.className = 'rp__store-address';
      var addrText = store.address || '';
      if (store.city || store.postal_code) {
        addrText += '\n' + [store.city, store.postal_code].filter(Boolean).join(', ');
      }
      addrEl.textContent = addrText;
      info.appendChild(addrEl);

      if (store.phone || store.hours) {
        var detailEl = document.createElement('div');
        detailEl.className = 'rp__store-detail';
        var parts = [];
        if (store.phone) parts.push(store.phone);
        if (store.hours) parts.push(store.hours);
        detailEl.textContent = parts.join('  •  ');
        info.appendChild(detailEl);
      }

      card.appendChild(info);

      card.addEventListener('click', function () {
        selectStore(store);

        /* Visual selection */
        storeList.querySelectorAll('.rp__store-card').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        card.classList.add('is-selected');
      });

      storeList.appendChild(card);
    });
  }

  function selectStore(store) {
    state.store = store;

    /* Update summary panel */
    if (selStoreName) selStoreName.textContent = store.name;
    if (selStoreAddr) {
      var addr = store.address || '';
      if (store.city || store.postal_code) {
        addr += ', ' + [store.city, store.postal_code].filter(Boolean).join(' ');
      }
      selStoreAddr.textContent = addr;
    }
    if (summaryStore) summaryStore.classList.add('is-visible');

    updateCtaState();
  }

  /* ---------- Init: fetch locations from Storefront API ---------- */
  fetchLocations().then(function (locations) {
    stores = locations;
  });

  /* ---------- Pincode proximity sort ---------- */
  function commonPrefixLength(a, b) {
    var len = Math.min(a.length, b.length);
    for (var i = 0; i < len; i++) {
      if (a[i] !== b[i]) return i;
    }
    return len;
  }

  function storeMatchScore(store, query) {
    var q = query.toLowerCase();
    var city = (store.city || '').toLowerCase();
    var postal = (store.postal_code || '').toLowerCase();
    var address = (store.address || '').toLowerCase();
    var name = (store.name || '').toLowerCase();

    /* Exact city match */
    if (city === q) return 100;
    /* City starts with query */
    if (city.indexOf(q) === 0) return 90;
    /* City contains query */
    if (city.indexOf(q) !== -1) return 80;
    /* Postal code prefix match */
    var pcPrefix = commonPrefixLength(q, postal);
    if (pcPrefix > 0) return 70 + pcPrefix;
    /* Address contains query */
    if (address.indexOf(q) !== -1) return 60;
    /* Store name contains query */
    if (name.indexOf(q) !== -1) return 50;

    return 0;
  }

  var searchTimeout;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        var q = searchInput.value.trim();
        if (!q) {
          if (storeList) storeList.innerHTML = '';
          if (skipWrap) skipWrap.classList.remove('is-visible');
          return;
        }
        var scored = stores.map(function (store) {
          return { store: store, score: storeMatchScore(store, q) };
        }).filter(function (item) {
          return item.score > 0;
        }).sort(function (a, b) {
          if (b.score !== a.score) return b.score - a.score;
          return (a.store.name || '').localeCompare(b.store.name || '');
        });
        var filtered = scored.map(function (item) { return item.store; });
        renderStores(filtered);
      }, 250);
    });
  }

  /* ---------- Skip store selection ---------- */
  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      state.store = null;
      state.skippedStore = true;
      if (summaryStore) summaryStore.classList.remove('is-visible');
      updateCtaState();
      goToStep(2);
    });
  }

  /* ---------- Step indicator click (navigate back to completed steps) ---------- */
  stepItems.forEach(function (el) {
    el.addEventListener('click', function () {
      var targetStep = parseInt(el.dataset.rpStep, 10);
      if (el.classList.contains('is-completed') && targetStep < state.step) {
        goToStep(targetStep);
      }
    });
  });

  /* ---------- CTA click handler ---------- */
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () {
      if (ctaBtn.disabled) return;

      if (state.step === 1 && state.store) {
        goToStep(2);
      } else if (state.step === 2) {
        submitReservation();
      }
    });
  }

  /* ---------- Checkmark SVG for completed badges ---------- */
  var checkSvg = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5L6.5 11.5L12.5 5.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Override goToStep to handle checkmarks */
  var _goToStep = goToStep;
  goToStep = function (n) {
    _goToStep(n);

    /* Inject checkmarks into completed badges */
    stepItems.forEach(function (el) {
      var badge = el.querySelector('.rp__step-badge');
      var s = parseInt(el.dataset.rpStep, 10);
      if (el.classList.contains('is-completed')) {
        badge.innerHTML = checkSvg;
      } else {
        badge.textContent = s;
      }
    });
  };

  /* ---------- Form validation ---------- */
  function validateForm() {
    var firstNameEl = page.querySelector('[data-rp-field="first_name"]');
    var lastNameEl  = page.querySelector('[data-rp-field="last_name"]');
    var emailEl     = page.querySelector('[data-rp-field="email"]');
    var phoneEl     = page.querySelector('[data-rp-field="phone"]');
    var privacyEl   = page.querySelector('[data-rp-field="privacy"]');

    var errors = [];

    page.querySelectorAll('.is-error').forEach(function (el) {
      el.classList.remove('is-error');
    });

    if (!firstNameEl || !firstNameEl.value.trim()) {
      errors.push('First name is required');
      if (firstNameEl) firstNameEl.classList.add('is-error');
    }

    if (!lastNameEl || !lastNameEl.value.trim()) {
      errors.push('Last name is required');
      if (lastNameEl) lastNameEl.classList.add('is-error');
    }

    if (!emailEl || !emailEl.value.trim()) {
      errors.push('Email is required');
      if (emailEl) emailEl.classList.add('is-error');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailEl.value.trim())) {
      errors.push('Please enter a valid email address');
      if (emailEl) emailEl.classList.add('is-error');
    }

    if (!phoneEl || !phoneEl.value.trim()) {
      errors.push('Phone number is required');
      if (phoneEl) phoneEl.classList.add('is-error');
    }

    if (!privacyEl || !privacyEl.checked) {
      errors.push('You must agree to the privacy policy');
    }

    if (errors.length > 0 && formErrors) {
      formErrors.textContent = errors.join('. ') + '.';
      formErrors.classList.add('is-visible');
    }

    return errors.length === 0;
  }

  /* ---------- Form submission ---------- */
  function submitReservation() {
    if (!validateForm()) return;

    var firstNameVal = page.querySelector('[data-rp-field="first_name"]').value.trim();
    var lastNameVal  = page.querySelector('[data-rp-field="last_name"]').value.trim();
    var emailVal     = page.querySelector('[data-rp-field="email"]').value.trim();
    var phoneCodeVal = (page.querySelector('[data-rp-field="phone_code"]') || {}).value || '+91';
    var phoneVal     = page.querySelector('[data-rp-field="phone"]').value.trim();
    var fullPhone    = phoneCodeVal + ' ' + phoneVal;
    var commentVal   = (page.querySelector('[data-rp-field="comment"]') || {}).value || '';

    state.customer = {
      firstName: firstNameVal,
      lastName: lastNameVal,
      name: firstNameVal + ' ' + lastNameVal,
      email: emailVal,
      phone: fullPhone,
      comment: commentVal.trim()
    };

    var storeSkipped = !state.store;
    var reservationData = {
      product: state.product ? {
        id: state.product.id,
        variantId: state.product.variantId,
        title: state.product.title,
        vendor: state.product.vendor,
        price: state.product.priceFormatted,
        handle: state.product.handle
      } : null,
      store: state.store ? {
        name: state.store.name,
        address: state.store.address,
        city: state.store.city,
        postal_code: state.store.postal_code,
        phone: state.store.phone,
        email: state.store.email
      } : null,
      storeSkipped: storeSkipped,
      customer: state.customer,
      timestamp: new Date().toISOString()
    };

    if (hiddenForm) {
      var setField = function (name, value) {
        var input = hiddenForm.querySelector('[name="' + name + '"]');
        if (input) input.value = value;
      };

      setField('contact[email]', emailVal);
      setField('contact[first_name]', firstNameVal);
      setField('contact[last_name]', lastNameVal);
      setField('contact[phone]', fullPhone);
      var lines = [
        'RESERVATION REQUEST',
        '=====================',
        ''
      ];

      lines.push('CUSTOMER DETAILS');
      lines.push('----------------');
      var c = reservationData.customer;
      lines.push('Name:    ' + c.name);
      lines.push('Email:   ' + c.email);
      lines.push('Phone:   ' + c.phone);
      if (c.comment) lines.push('Notes:   ' + c.comment);
      lines.push('');

      if (reservationData.product) {
        lines.push('PRODUCT');
        lines.push('-------');
        var p = reservationData.product;
        lines.push('Item:       ' + p.title);
        if (p.vendor) lines.push('Brand:      ' + p.vendor);
        lines.push('Variant ID: ' + p.variantId);
        lines.push('Price:      ' + p.price);
        if (p.handle && shopDomain) {
          lines.push('URL:        https://' + shopDomain + '/products/' + p.handle);
        }
        lines.push('');
      }

      lines.push('STORE');
      lines.push('-----');
      if (reservationData.store) {
        var s = reservationData.store;
        lines.push('Location:   ' + s.name);
        var fullAddr = [s.address, s.city, s.postal_code].filter(Boolean).join(', ');
        if (fullAddr) lines.push('Address:    ' + fullAddr);
        if (s.phone) lines.push('Phone:      ' + s.phone);
        if (s.email) lines.push('Email:      ' + s.email);
      } else {
        lines.push('No store selected — customer skipped store selection.');
        lines.push('Please follow up to assign a preferred store.');
      }
      lines.push('');

      lines.push('---');
      lines.push('Submitted on ' + new Date(reservationData.timestamp).toLocaleString());

      setField('contact[body]', lines.join('\n'));
    }

    if (ctaBtn) {
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'SUBMITTING...';
    }

    /* Send to Azure Function for email notification */
    var apiBase = page.dataset.formsApi || 'https://rockrevival-func789.azurewebsites.net';

    var payload = {
      formType: 'reserve',
      data: {
        firstName: firstNameVal,
        lastName: lastNameVal,
        name: state.customer.name,
        email: emailVal,
        phone: fullPhone,
        comment: state.customer.comment,
        product: reservationData.product,
        store: reservationData.store,
        storeSkipped: storeSkipped,
        timestamp: reservationData.timestamp
      }
    };

    fetch(apiBase + '/api/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (result) {
        if (result.ok && result.body && result.body.success) {
          onSubmitSuccess(reservationData);
        } else {
          onSubmitError();
        }
      })
      .catch(function () {
        onSubmitError();
      });
  }

  function onSubmitSuccess(data) {
    goToStep(3);

    try {
      document.dispatchEvent(new CustomEvent('reservation:completed', { detail: data }));
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'reservation_completed', reservation: data });
      }
    } catch (e) { /* analytics should not break flow */ }
  }

  function onSubmitError() {
    if (formErrors) {
      formErrors.textContent = 'Something went wrong. Please try again.';
      formErrors.classList.add('is-visible');
    }
    if (ctaBtn) {
      ctaBtn.disabled = false;
      ctaBtn.textContent = 'RESERVE IN STORE';
    }
  }

  /* ---------- Continue shopping ---------- */
  var continueBtn = page.querySelector('[data-rp-continue]');
  if (continueBtn) {
    continueBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/';
    });
  }
})();
